import { Box, Typography } from '@mui/material';
import { FONT_SERIF, WD } from '../../../warningDashboard/warningTheme';
import Panel from './Panel';

/** What anybody outside the Technical Department sees - the server's refusal, as a notice rather than an error. */
export default function NotAllowed({ message }) {
  return (
    <Box display="grid" sx={{ placeItems: 'center', minHeight: '50vh' }}>
      <Panel sx={{ p: 4, maxWidth: 440, textAlign: 'center' }}>
        <Typography component="h1" sx={{ fontFamily: FONT_SERIF, fontSize: 22, fontWeight: 600, color: WD.ink }}>Technical Department only</Typography>
        <Typography sx={{ mt: 1, fontSize: 13.5, lineHeight: 1.6, color: WD.inkMuted }}>
          {message || 'The workload dashboard is available to Technical Department staff.'}
        </Typography>
      </Panel>
    </Box>
  );
}
